import Backbone from 'backbone'
import constants from 'scoreboard/components/constants'

var Database = Backbone.Model.extend({

	section: 'admin',

	urlRoot: 'api/admin/databases'

}, {

	getDefaultPort(product) {
		let port = constants.DEFAULT_MY_SQL_PORT
		switch (product) {
			case 'sqlserver': port = constants.DEFAULT_SQL_SERVER_PORT; break
			case 'oracle': port = constants.DEFAULT_ORACLE_PORT; break
			case 'db2': port = constants.DEFAULT_DB2_PORT; break
			case 'hana': port = constants.DEFAULT_HANA_PORT; break
		}
		return port
	}

})

export default Database

Database.__filename__ = 'admin/connections/database.js'
